import { render } from "./SetPassword.vue?vue&type=template&id=2b39df5a&scoped=true&ts=true"
import script from "./SetPassword.vue?vue&type=script&lang=ts"
export * from "./SetPassword.vue?vue&type=script&lang=ts"

import "./SetPassword.vue?vue&type=style&index=0&id=2b39df5a&lang=less&scoped=true"

import exportComponent from "/root/workspace/pt-manage-plugin-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b39df5a"]])

export default __exports__